<template>
  <div id="app">
    <a-config-provider :locale="zh_CN">
      <router-view />
    </a-config-provider>
    <a-space v-show="beian" >
      <div>四川珅鑫科技有限公司</div>
      <a href="https://beian.miit.gov.cn/" target="_blank">蜀ICP备2024094312号-1</a>
    </a-space>
  </div>
</template>

<script>
import zh_CN from 'ant-design-vue/lib/locale-provider/zh_CN'

export default {
  name: 'App',
  data() {
    return {
      beian: false,
      zh_CN,
    }
  },
  mounted() {
    setTimeout(() => {
      this.beian = true
    }, 1000)
  },
}
</script>

<style>
html {
  height: auto;
  background-color: #ffffff;
}

body {
  height: auto;
  margin: 0;
  padding: 0;
}

#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  height: auto;
}
.panel .ant-table {
  min-height: 220px !important;
}

.discarded-pic {
  height: 100px;
  margin-right: 80px;
  float: right;
}
@media print {
  #printContent {
    /* width: 241mm; */
    font-family: Microsoft YaHei !important;
    color: #000 !important;
  }
}
</style>
